import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import type { CompanyFilters, CompanyListRequest } from 'types'

import { companyCount, companyGet, companyList } from './company.service'

export const companyKeyFactory = {
  base: () => ['companies'],
  list: (request?: CompanyListRequest) => [
    ...companyKeyFactory.base(),
    'list',
    ...(request ? [request] : []),
  ],
  count: (filters?: CompanyFilters) => [
    ...companyKeyFactory.base(),
    'count',
    ...(filters ? [filters] : []),
  ],
  get: (uuid?: string) => [
    ...companyKeyFactory.base(),
    'get',
    ...(uuid ? [uuid] : []),
  ],
}

export const queryCompanyList = (request: CompanyListRequest) =>
  queryOptions({
    queryKey: companyKeyFactory.list(request),
    queryFn: () => companyList(request),
    placeholderData: keepPreviousData,
  })

export const queryCompanyCount = (filters?: CompanyFilters) =>
  queryOptions({
    queryKey: companyKeyFactory.count(filters),
    queryFn: () => companyCount(filters),
    placeholderData: keepPreviousData,
  })

export const queryCompanyGet = (uuid: string) =>
  queryOptions({
    queryKey: companyKeyFactory.get(uuid),
    queryFn: () => companyGet(uuid),
  })
